import type { NoteEntry } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import NarrativeDisplay from "./NarrativeDisplay"

interface Props {
	entries: NoteEntry[]
}

const listStyles = css`
	margin: 0;
	padding: 0;
	list-style: none;

	& > li {
		margin: 0;
		padding: 0;
	}
`

const NarrativeList: ReactiveComponent<Props> = (props) => {
	return () => (
		<ul class={listStyles}>
			{props.entries.map((note, i) => (
				<li key={i}>
					{i !== 0 && <hr />}
					<NarrativeDisplay note={note} />
				</li>
			))}
		</ul>
	)
}

export default defineComponent(NarrativeList, inferProps<Props>())
